import { div } from "framer-motion/client";
import React, { useState } from "react";

const FAQAccordion = ({ data }) => {
    // const [openIndex, setOpenIndex] = useState(null);
const [openIndex, setOpenIndex] = useState(0);
    return (
        <div>
            <h3 className="text-[#666] font-semibold text-[24px] md:text-[28px] mt-12 md:mt-22 mb-4">
                Frequently Asked Questions
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 max-w-full md:max-w-[980px]">
                {data.map((item, index) => (
                    <div key={index}>
                        <button
                            onClick={() =>
                                setOpenIndex(openIndex === index ? null : index)
                            }
                            className="w-full flex items-center justify-between text-left py-2"
                        >
                            <h3 className="text-[18px] text-[#666] font-semibold">
                                {item.question}
                            </h3>

                            <svg
                                className={`w-5 h-5 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""
                                    }`}
                                fill="none"
                                stroke="#666"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </button>

                        <div
                            className={`transition-all duration-300 overflow-hidden ${openIndex === index
                                    ? "max-h-96 opacity-100 mt-3"
                                    : "max-h-0 opacity-0"
                                }`}
                        >
                            <p className="text-[#4E4E4E] text-[14px] md:text-[16px]">
                                {item.answer}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQAccordion;